import _ from 'lodash';

function satisfiesCondition(operator, total, target) {
  if (operator === 'equalTo' && total === target) {
    return true;
  }
  if (operator === 'greaterThan' && total > target) {
    return true;
  }
  return operator === 'greaterThanEqualTo' && total >= target;
}

const getTotalProductCombinations = (
  availableEligibleItems,
  comparisonOperator,
  numericTarget,
  totalQuantity = {},
  propertyName = 'weightInMg'
) => {
  const {
    enabled: totalQuantityEnabled = false,
    quantity: targetQuantity = 0,
    quantityOperator = 'equalTo',
  } = totalQuantity;
  let combinations = [];
  const fork = (index = 0, quantity = 1, total = 0, combo = { items: {}, totalQuantity: 0 }) => {
    const item = availableEligibleItems[index];
    const forkSatisfied = satisfiesCondition(comparisonOperator, total, numericTarget);
    if (forkSatisfied) {
      combinations.push(combo);
      // If weight is equalTo and total quantity is not enabled, we can stop going down this branch here
      if (comparisonOperator === 'equalTo' && !totalQuantityEnabled) {
        return;
      }
    }

    if (!item) {
      return;
    }

    const newTotal = total + item[propertyName] * quantity;

    if (
      comparisonOperator === 'greaterThanEqualTo' ||
      comparisonOperator === 'greaterThan' ||
      newTotal <= numericTarget
    ) {
      if (item.quantity > quantity) {
        fork(index, quantity + 1, total, combo);
      }
      fork(index + 1, 1, newTotal, {
        items: { ...combo.items, [item.key]: { ...item, quantity } },
        totalQuantity: combo.totalQuantity + quantity,
      });
    }

    if (quantity < 2) {
      fork(index + 1, 1, total, combo);
    }
  };

  fork();

  // Filter all combinations that don't match the allowed totalQuantity parameters
  if (totalQuantityEnabled) {
    combinations = _.filter(combinations, (combo) =>
      quantityOperator === 'greaterThan' ? combo.totalQuantity > targetQuantity : combo.totalQuantity === targetQuantity
    );
  }

  // If totalWeight is greaterThan on it's own or totalWeight is greaterThan combined with greaterThan totalQuantity,
  // sort combinations by least number of items required to greatest
  if (
    (comparisonOperator === 'greaterThan' || comparisonOperator === 'greaterThanEqualTo') &&
    (!totalQuantityEnabled || quantityOperator !== 'equalTo')
  ) {
    combinations = _.uniq(_.sortBy(combinations, 'totalQuantity'));
  }

  return _.uniq(combinations);
};

export default getTotalProductCombinations;
